import { createSlice } from '@reduxjs/toolkit';

import { moveFromPendingToCutting } from './api';

export const VendorClearance = createSlice({

    name: 'VendorClearance',
    initialState: {
        loading: false,
        error: '' ,
        clearVendorSuccess: false,
    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clear: (state, action) => {
          if(action?.payload?.key) {
            return {
              ...state,
              [action.payload.key]: action.payload.value
            }
          }
          return { ...state }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(moveFromPendingToCutting.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(moveFromPendingToCutting.fulfilled, (state, action) => {
            state.loading = false;
            state.clearVendorSuccess = true;
        })
        builder.addCase(moveFromPendingToCutting.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        })
    }
})

export const {clearError, clear} = VendorClearance.actions
export default VendorClearance.reducer